import { render } from "./Switchin.vue?vue&type=template&id=955396be&scoped=true"
import script from "./Switchin.vue?vue&type=script&lang=js"
export * from "./Switchin.vue?vue&type=script&lang=js"

import "./Switchin.vue?vue&type=style&index=0&id=955396be&lang=css"
import "./Switchin.vue?vue&type=style&index=1&id=955396be&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-955396be"]])

export default __exports__